import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

export const ProtectedRoute = ({ children, requiredRoles }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  console.log('ProtectedRoute check:', { isAuthenticated, user, requiredRoles });

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to homepage');
    return <Navigate to="/" replace />;
  }

  if (requiredRoles && user && !requiredRoles.includes(user.role)) {
    console.log('User role not authorized, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('Access granted');
  return <>{children}</>;
};
